import axios from 'axios';
import Cookies from 'js-cookie'
import signature  from '@/services/signature';
import CryptoJS  from 'crypto-js';

// const BASE_URI = process.env.API_BASE_URI;

class AuthService {
    setUrl(newUrl) {
        this.base_url = newUrl
    }
    login(globalId) {
      let data = {
        'global_id': globalId
      };
      Cookies.remove('planTrialPeriod', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('planTrialStartsAt', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('planTrialEndsAt', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('planTenantID', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('mask_phone', { domain: '.' + process.env.CENTRAL_API_ROOT });

      return axios.post(this.base_url + '/v2/auth/login' + signature(), data).then(async response => {
        if (response.data.data.access_token) {
          let user = response.data.data;

          Cookies.set('tenantToken', user.access_token, { domain: '.' + process.env.CENTRAL_API_ROOT });
          delete user.access_token;

          Cookies.set('bookmarks', JSON.stringify(user.bookmarks), { domain: '.' + process.env.CENTRAL_API_ROOT });
          delete user.bookmarks;

          await fetch(user.profile_url).then(response => {
            if (response.status != 200) {
              user.profile_url = '';
            }
          }).catch(error => {
            user.profile_url = '';
          });
          user.announcements = user.announcements.length;

          delete user.login_date
          delete user.created_date
          delete user.updated_date

          Cookies.set('user', JSON.stringify(user), { domain: '.' + process.env.CENTRAL_API_ROOT });

          let plan = response.data.plan;

          Cookies.remove('features', { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('features', JSON.stringify(plan.features), { domain: '.' + process.env.CENTRAL_API_ROOT });
          delete plan.features;

          plan.apps = plan.apps.filter(({slug = ''}) => !slug.includes("app-slip-verification-credit"))

          Cookies.set('plan', JSON.stringify(plan), { domain: '.' + process.env.CENTRAL_API_ROOT });
          let expiredPlans = [];
          if (response.data.expired_plans) {
            const groupedData = response.data.expired_plans.reduce((acc, item) => {
              if (!acc[item.series] || new Date(item.expire_date) > new Date(acc[item.series].expire_date)) {
                acc[item.series] = item;
              }
              return acc;
            }, {});

            expiredPlans = Object.values(groupedData);

          }
          Cookies.set('expiredPlans', JSON.stringify(expiredPlans), { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('menus', JSON.stringify(response.data.menus), { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('WmsSevice', JSON.stringify(response.data.tenant.wms_step), { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('wmsServicePermission', JSON.stringify(user.wms_service_permissions), { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('wmsServiceId', JSON.stringify(response.data.tenant.wms_id), { domain: '.' + process.env.CENTRAL_API_ROOT });
          Cookies.set('WmsWarehouseLimit', JSON.stringify(response.data.tenant.wms_warehouse_limit), { domain: '.' + process.env.CENTRAL_API_ROOT });
          if (response.data.expired_integraions) {
            Cookies.set('countExpiredGochats', response.data.expired_integraions.gochats.length, { domain: '.' + process.env.CENTRAL_API_ROOT });
            Cookies.set('countExpiredMarketplaces', response.data.expired_integraions.marketplaces.length, { domain: '.' + process.env.CENTRAL_API_ROOT });
          }

          const tenant = response.data.tenant
          //remove key here
          const tenantObj = {
            id : tenant.id,
            wallet_shipment : tenant.wallet_shipment,
            wallet_sms : tenant.wallet_sms,
            name : tenant.name,
            need_upgrade_integration : tenant.need_upgrade_integration,
            need_upgrade_bank_account : tenant.need_upgrade_bank_account,
            need_upgrade_business_info : tenant.need_upgrade_business_info,
            need_upgrade_order_notification : tenant.need_upgrade_order_notification,
            need_upgrade_flat_rate : tenant.need_upgrade_flat_rate,
            password_policy : tenant.password_policy,
            logo : tenant.logo,
            code : tenant.code,
            merchant : tenant.merchant,
            idt : tenant.industry,
            tenancy_db_connection : tenant.tenancy_db_connection,
            stock_shortcut : tenant.stock_shortcut ,
          }

          Cookies.set('tenant', JSON.stringify(tenantObj), { domain: '.' + process.env.CENTRAL_API_ROOT });

          let dataStatic = response.data.data_static
          await fetch(dataStatic.address).then(response => {
            if (response.status != 200) {
              dataStatic.address = false;
            }
          }).catch(error => {
            dataStatic.address = false;
          });
          Cookies.set('dbAddress', dataStatic.address, { domain: '.' + process.env.CENTRAL_API_ROOT });

          const domain = (new URL(response.config.url).host.split(".")[0])
          Cookies.set('online', window.btoa(domain))
        }
        return { message: 'Failed login!' };
      });
    }
    logout() {
      Cookies.remove('tenantToken', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('bookmarks', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('user', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('features', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('plan', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('expiredPlans', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('menus', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('tenant', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('WmsSevice', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('countExpiredGochats', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('countExpiredMarketplaces', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('dbAddress', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('mask_phone', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('totalStores', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('userProfile', { domain: '.' + process.env.CENTRAL_API_ROOT });
      Cookies.remove('online');
      localStorage.removeItem("provinces");
    }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/auth.tenant.service.js